import { Paper, ThemeProvider, Stack, CssBaseline, Box } from "@mui/material";
import * as React from "react";
import ChangePasswordForm from "components/jkt/auth/changePasswordForm";
import AppBar from "components/jkt/global/menuBar";
import { styled } from "@mui/material/styles";
import { theme } from "components/jkt/global/theme";
import Toolbar from "@mui/material/Toolbar";
import V2sessionTimeout from "components/jkt/global/v2SessionTimeout";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.primary,
}));

const ChangePasswordPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <AppBar pageName={"Change Password"} />
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          <Toolbar />
          <Stack sx={{ mt: 5 }} gap={5}>
            <Stack spacing={2} direction="row" justifyContent="center">
              <Item sx={{ borderRadius: "1rem" }}>
                <ChangePasswordForm />
              </Item>
            </Stack>
          </Stack>
        </Box>
      </Box>
      <V2sessionTimeout />
    </ThemeProvider>
  );
};
export default ChangePasswordPage;
